import { Route, Routes } from '@angular/router';
import { authGuard, roleGuard } from './core/auth/auth.guard';

// Schermate del flusso intervista: stessa componente con e senza id della pratica nel path
// (/interview e /interview/<id>): l'id compare appena la riga esiste e permette il ripristino
// post-refresh (v. SessionStore._syncIdInUrl/_restoreFromUrl). Stesso import = stesso chunk.
const flow = (path: string, loadComponent: Route['loadComponent']): Routes => [
  { path, loadComponent },
  { path: `${path}/:id`, loadComponent },
];

// Flusso a wizard: ogni schermata è una route lazy (chunk separato).
// La navigazione è centralizzata in SessionStore; i path coincidono col tipo Screen.
export const routes: Routes = [
  { path: 'login', loadComponent: () => import('./features/login/login').then((m) => m.Login) },
  // Link personale di misura (§3 doc DEV_v7): pubblico, nessun login — sibling di 'login', FUORI
  // dal blocco guardato da authGuard sotto. La verifica del token vive nella RPC (0020), non qui.
  {
    path: 'q/:token',
    loadComponent: () => import('./features/measurement-session/measurement-session').then((m) => m.MeasurementSession),
  },
  {
    path: '',
    canActivateChild: [authGuard],
    children: [
      { path: '', redirectTo: 'intro', pathMatch: 'full' },
      { path: 'intro', loadComponent: () => import('./features/intro/intro').then((m) => m.Intro) },
      ...flow('scheda', () => import('./features/scheda/scheda').then((m) => m.Scheda)),
      ...flow('document', () => import('./features/document/document').then((m) => m.DocumentScreen)),
      // Intervista: senza id su /interview, con id su /interviews/<id> — coerente con
      // l'archivio /interviews (lista) → /interviews/<id> (pratica singola).
      { path: 'interview', loadComponent: () => import('./features/interview/interview').then((m) => m.Interview) },
      { path: 'interviews/:id', loadComponent: () => import('./features/interview/interview').then((m) => m.Interview) },
      ...flow('processing', () => import('./features/processing/processing').then((m) => m.Processing)),
      ...flow('validation', () => import('./features/validation/validation').then((m) => m.Validation)),
      ...flow('chiarimenti', () => import('./features/chiarimenti/chiarimenti').then((m) => m.Chiarimenti)),
      ...flow('profile', () => import('./features/profile/profile').then((m) => m.Profile)),
      ...flow('ponderazione', () => import('./features/ponderazione/ponderazione').then((m) => m.Ponderazione)),
      ...flow('profondita', () => import('./features/profondita/profondita').then((m) => m.Profondita)),
      ...flow('rating', () => import('./features/rating/rating').then((m) => m.Rating)),
      {
        path: 'interviews',
        loadComponent: () => import('./features/interviews/interviews').then((m) => m.Interviews),
      },
      {
        path: 'survey/iip/:id/:participantId/:rilevazione',
        data: { kind: 'iip' },
        loadComponent: () => import('./features/survey/survey').then((m) => m.Survey),
      },
      {
        path: 'survey/ibap/:id/:participantId/:rilevazione',
        data: { kind: 'ibap' },
        loadComponent: () => import('./features/survey/survey').then((m) => m.Survey),
      },
      {
        path: 'admin',
        canActivate: [roleGuard(['ADMIN'])],
        loadComponent: () => import('./features/admin/admin').then((m) => m.Admin),
      },
    ],
  },
  { path: '**', redirectTo: 'intro' },
];
